<p-multiSelect 
    [options]="list" 
    [(ngModel)]="selectedItem" 
    defaultLabel="Selecione a Etapa" 
    optionLabel="text"
    (ngModelChange)="onSelectionChange($event)"  
    selectedItemsLabel="{0} Item(ns) Selecionado(s)"
    [style]="{'width':'100%'}"
    [panelStyle]="{'max-width': '100%'}">
</p-multiSelect>